import React, { useEffect, useState } from "react";
import "./Footer.css";
import { Link as Anchor } from "react-router-dom";
import baseURL from "../url";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import footerLogo from "../../images/footer_logo.png";

export default function Footer() {
  const [tienda, setTienda] = useState([]);
  const [categorias, setCategorias] = useState([]);

  useEffect(() => {
    cargarCategorias();
    cargarTienda();
  }, []);

  const cargarCategorias = () => {
    fetch(`${baseURL}/categoriasGet.php`, { method: "GET" })
      .then((response) => response.json())
      .then((data) => {
        const shuffledCategorias = data.categorias?.sort(() => 0.5 - Math.random());
        setCategorias(shuffledCategorias.slice(0, 3));
      })
      .catch((error) => console.error("Error al cargar datos:", error));
  };

  const cargarTienda = () => {
    fetch(`${baseURL}/tiendaGet.php`, { method: "GET" })
      .then((response) => response.json())
      .then((data) => {
        setTienda(data.tienda.reverse()[0] || []);
      })
      .catch((error) => console.error("Error al cargar datos:", error));
  };

  return (
    <div className="FooterContain">
      <div className="footer-column">
        <Anchor to="/">
          {tienda?.imagen1 ? (
            <img className="logoFooter" src={footerLogo} alt="logo" />
          ) : (
            <></>
          )}
        </Anchor>
        <h2>CESECO Psicología y Educación</h2>
        <span>Terapia para adultos y adolescentes</span>
      </div>

      <div className="footer-column">
        <h3>Contacto</h3>
        <Anchor
          to={`https://www.google.com/maps?q=Calle cajón S/N (frente al # 107) colonia Villas del Cimatario. Querétaro, Qro.`}
          target="_blank"
        >
          Calle cajón S/N (frente al # 107) colonia Villas del Cimatario. Querétaro, Qro.
        </Anchor>
        {/* <Anchor to={`mailto:${tienda.email}`} target="_blank">
          {tienda.email}
        </Anchor> */}
        {/* <div className="socials"> TODO: DEFINIR REDES SOCIALES
          <Anchor to={tienda.instagram} target="_blank">
            <i className="fa fa-instagram"></i>
          </Anchor>
          <Anchor to={`tel:${tienda.telefono}`} target="_blank">
            <i className="fa fa-whatsapp"></i>
          </Anchor>
          <Anchor to={tienda.facebook} target="_blank">
            <i className="fa fa-facebook"></i>
          </Anchor>
        </div> */}
      </div>

      <div className="footer-column">
        <h3>Centros</h3>
        {categorias?.map((item, index) => (
          <Anchor key={index}>{item.categoria}</Anchor>
        ))}
      </div>

      <div className="footer-column">
        <h3>Acceso</h3>
        <Anchor to={`/dashboard`} className="btnAnch">
          <FontAwesomeIcon icon={faUser} /> Dashboard
        </Anchor>
      </div>
    </div>
  );
}
